<template>
  <van-list
    class="px-10 list"
    v-model="loading"
    :immediate-check="false"
    :finished="finished"
    :finished-text="finishedText"
    @load="load">
    <div
      class="mt-10 item"
      v-for="(n, i) of datas"
      :key="`list-${i}`"
      @click="$router.push({ name: 'shop-order-view', params: { id: n.id } })">
      <div class="row-time fy">{{ n.createTime }}</div>
      <div class="flex-row flex-j-sb flex-a-c">
        <div class="mr-20 thumb"><img :src="n.coverImg" /></div>
        <!-- 图片懒加载 -->
        <!-- 	<div class="mr-20 thumb"><img v-lazy="n.coverImg"/></div> -->
        <div class="mr-20 info">
          <div class="fs-16 row-title fy">
            <b>{{ n.title }}</b>
          </div>
          <div class="fs-12 mt-5 color-gray-dark fy">{{ n.des }}</div>
          <!-- <div class="fs-18 mt-5">
            <b>
              ¥{{ n.price }}
              <span class="fs-12 ml-10">x{{ n.num }}</span>
            </b>
          </div> -->
        </div>
        <!-- 新 购买数量 -->
        <div class="right-icon">x{{ n.num }}</div>

        <!-- 右侧箭头 -->
        <!-- <div class="right-icon"><van-icon class="color-gray-dark" name="arrow" /></div> -->
      </div>

      <div class="ta-r color-golden">消费积分：{{ n.payAmount }}</div>
    </div>
  </van-list>
</template>

<script>
import { List, Icon } from "vant"
import * as GoodsApi from "@/api/goods"

export default {
  name: "list-tab",
  props: {
    status: {
      type: [String, Number],
      required: true
    }
  },
  data: () => ({
    loading: false,
    finished: false,
    finishedText: "",
    datas: [],
    form: {
      fields: {
        status: "",
        time: "all",
        pageSize: 10,
        pageNo: 1
      }
    }
  }),
  methods: {
    load() {
      this.loading = true
      this.form.fields.status = this.status
      GoodsApi.orderList(this.form.fields)
        .then((data) => {
          this.datas = this.datas.concat(data.list)
          if (data.list.length === 0) {
            this.finishedText = "暂无订单"
          } else {
            this.finishedText = "已经到底了"
          }
          if (data.list.length < 10) {
            this.finished = true
          } else {
            this.form.fields.pageNo++
          }
          this.loading = false
        })
        .catch((e) => {
          this.finished = true
          this.loading = false
          this.finishedText = "暂无订单"
        })
    },
    statusText(status) {
      let statusMap = {
        0: "待付款",
        10: "待发货",
        11: "待收货",
        12: "已完成",
        20: "已取消",
        30: "退货中",
        31: "已退款"
      }
      return statusMap[status]
    }
  },
  components: {
    [List.name]: List,
    [Icon.name]: Icon
  }
}
</script>

<style lang="less" scoped>
.item {
  padding: 15px 5px 5px 15px;
  background: #fff;
  border-radius: 5px;
  align-items: center;
  .thumb {
    width: 25vw;
    img {
      width: 100%;
      height: auto;
    }
  }
  .info {
    flex: 1;
    // border: 1px solid #1989FA;
  }
}
</style>